var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container-wrapper"},[_c('div',{staticClass:"error-container"},[_c('div',{staticClass:"error-image",attrs:{"aria-hidden":"true"}},[_c('img',{attrs:{"src":_vm.errorIconSource}})]),_c('div',{staticClass:"error-text"},[_vm._t("default",function(){return [_vm._v("Hov, noget gik galt")]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }